// ====== NAV ======
const navbar = document.getElementById('navbar');
window.addEventListener('scroll', () => {
  navbar.classList.toggle('scrolled', window.scrollY > 60);
});

function openSubscribe(e) {
  e.preventDefault();
  document.getElementById('subscribeOverlay').classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeSubscribe() {
  document.getElementById('subscribeOverlay').classList.remove('active');
  document.body.style.overflow = '';
}

function openContact(e) {
  e.preventDefault();
  document.getElementById('contactOverlay').classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeContact() {
  document.getElementById('contactOverlay').classList.remove('active');
  document.body.style.overflow = '';
}

function goHome(e) {
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') { closeSubscribe(); closeContact(); }
});

const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
    }
  });
}, observerOptions);

document.querySelectorAll('.model-card, .planned-card').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(30px)';
  el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  observer.observe(el);
});
